// extracted by mini-css-extract-plugin
export default {"complianceLinks":"styles_complianceLinks__0CAZE"};